import $ from 'jquery';

import Product from './Product';

const DEBUG = false;

function _onContentClick(event) {
  event.stopPropagation();
}

export default class Quickshop {
  constructor() {
    this.el = document.querySelector('[data-quickshop]');
    this.contentEl = document.querySelector('[data-quickshop-content]');
    this.closeEl = document.querySelector('[data-quickshop-close]');
    this.injectEl = this.el.querySelector('[data-quickshop-product-inject]');
    this.settingsSha256 = this.el.getAttribute('data-quickshop-settings-sha256');
    this.useCaching = !DEBUG && !(window.Shopify && window.Shopify.designMode);

    this.deferred = {};

    this.onCloseClick = this.close.bind(this);
  }

  load(url, productSha256) {
    let data;
    if (url in this.deferred) {
      return this.deferred[url];
    }

    const $deferred = $.Deferred();

    this.deferred[url] = $deferred;

    if (this.useCaching) {
      data = sessionStorage.getItem(url);

      if (data) {
        const deserialized = JSON.parse(data);

        if (
          (productSha256 === deserialized.options.product_sha256) &&
          (this.settingsSha256 === deserialized.options.settings_sha256)
        ) {
          delete this.deferred[url];

          return $deferred.resolve(deserialized).promise();
        }
      }
    }

    this.url = url;

    $.ajax({
      url,
      data: 'view=ajax',
      dataType: 'html',
      success: (response) => {
        const el = document.createElement('div');
        el.innerHTML = response;

        const options = JSON.parse(el.querySelector('[data-product-options]').innerHTML);
        const html = el.querySelector('[data-product-html]').innerHTML;

        if (this.useCaching) {
          try {
            sessionStorage.setItem(
              url,
              JSON.stringify({ options, html }),
            );
          } catch (error) {
            console.error(error);
          }
        }

        delete this.deferred[url];
        return $deferred.resolve({ options, html });
      },
      error: () => {
        delete this.deferred[url];
        return $deferred.reject();
      }
      ,
    });

    return $deferred.promise();
  }

  open(url, productSha256) {
    const $deferred = $.Deferred();

    this.el.addEventListener('click', this.onCloseClick);
    this.contentEl.addEventListener('click', _onContentClick);
    this.closeEl.addEventListener('click', this.onCloseClick);

    this.el.classList.add('quickshop-visible');

    this.load(url, productSha256).done((data) => {
      this.injectEl.innerHTML = data.html;
      this.product = new Product({ el: this.injectEl, data: data.options });
      this.el.classList.add('quickshop-loaded');

      return $deferred.resolve();
    }).fail($deferred.reject());

    return $deferred.promise();
  }

  close() {
    if (this.product != null) {
      this.product.unload();
    }

    this.el.removeEventListener('click', this.onCloseClick);
    this.contentEl.removeEventListener('click', _onContentClick);
    this.closeEl.removeEventListener('click', this.onCloseClick);

    this.el.classList.remove('quickshop-loaded');
    return this.el.classList.remove('quickshop-visible');
  }

  unload() {
    return this.close();
  }
}
